import { render } from "./ScreenThree.vue?vue&type=template&id=6fa55c86&scoped=true"
import script from "./ScreenThree.vue?vue&type=script&lang=js"
export * from "./ScreenThree.vue?vue&type=script&lang=js"

import "./ScreenThree.vue?vue&type=style&index=0&id=6fa55c86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fa55c86"]])

export default __exports__